import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./App.css";
import MainNavbar from "./components/shared/MainNavbar";
import GeneralParams from "./components/shared/GeneralParams";
import Tables from "./components/tables/Tables";
import AdvTypes from "./components/tables/advtypes/AdvTypes";
import Departments from "./components/tables/departments/Departments";
import Members from "./components/tables/members/Members";
import Places from "./components/tables/places/Places";
import NazeegTypes from "./components/tables/nazeegtypes/NazeegTypes";
import PtorReasons from "./components/tables/ptorreason/PtorReasons";
import HakalaReasons from "./components/tables/hakalareason/HakalaReasons";
import Mayors from "./components/tables/mayors/Mayors";
import Hotmeem from "./components/tables/hotmeem/Hotmeem";
import JobTypes from "./components/tables/jobtypes/JobTypes";
import Jobs from "./components/tables/jobs/Jobs";
import Users from "./accounts/users/Users";
import GetLoggedInUsers from "./accounts/users/GetLoggedInUsers";
import GetLoginLog from "./accounts/users/GetLoginLog";
import AmotMedaCats from "./components/tables/AmotMedaCat/AmotMedaCats";
import EvaluationInstitute from "./components/tables/evaluationinstitute/EvaluationInstitute";
import Mekhrazeem from "./components/mechrazeem/Mekhrazeem";
import GetMekhrazeem from "./components/moamdootreview/GetMekhrazeem";
import DisplayMoamadiot from "./components/moamdootreview/DisplayMoamdiot";
import Add from "./components/mechrazeem/Add";
import MekhrazAdmin from "./components/mekhrazmanager/MekhrazAdmin";
import BhinaMeetingAdmin from "./components/bhinameeting/BhinaMeetingAdmin";
import MoamadAdmin from "./components/moamadmanager/MoamadAdmin";
import Moamadoiot from "./components/moamadoot/Moamadoiot";
import Moamadoot from "./components/moamadoot/Moamadoot";
import Reports from "./components/reports/Reports";
import Login from "./accounts/Login";
import ResetPassword from "./accounts/ResetPassword";
import ResetPasswordConfirmation from "./accounts/ResetPasswordConfirmation";
import Register from "./accounts/Register";
import Logout from "./accounts/Logout";
import Home from "./components/Home";
import Missing from "./accounts/Missing";
import RequireAuth from "./accounts/RequireAuth";
import SessionWarningModal from "./components/SessionWarningModal";
import ExportDataButton from "./accounts/users/ExportDataButton";
import ExportMekhrazeemButton from "./accounts/users/ExportMekhrazeemButton";
import ExportMoamadeemButton from "./accounts/users/ExportMoamadButton";
import ConfirmActivation from "./accounts/ConfirmActivation";
import { useIdleTimeout } from "./hooks/useIdleTimeout";
const human_assest_003_link = "human-assets003.pdf";
function App() {
  const [counter, setCounter] = useState(0);
  const increment = () => {
    setCounter(counter + 1);
  };
  const navigate = useNavigate();

  const handleTimeout = () => {
    localStorage.removeItem("token"); // נקה את ה-token
    navigate("/logout", { state: { reason: "timeout" } }); // הפנה ל-login
  };

  useIdleTimeout(handleTimeout);
  return (
    <>
      <MainNavbar />
      <div className="container">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Register />} />
          <Route path="/confirm-activation" element={<ConfirmActivation />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route
            path="/resetpasswordconfirmation/:uid/:token"
            element={<ResetPasswordConfirmation />}
          />
          <Route exaxt path="/" element={<Home />} />
          <Route
            element={
              <RequireAuth allowedRoles={["managers", "editors", "viewers"]} />
            }
          >
            <Route
              path="/humanassets"
              element={<Navigate to={human_assest_003_link} target="_blank" />}
            />
            <Route path="/generalparams" element={<GeneralParams />} />
            <Route path="/tables" element={<Tables />} />
            <Route path="/mekhrazeem" element={<Mekhrazeem />} />
            <Route path="/addmekhraz" element={<Add />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/places" element={<Places />} />
            <Route path="/advtypes" element={<AdvTypes />} />
            <Route path="/nazeegtypes" element={<NazeegTypes />} />
            <Route path="/members" element={<Members />} />
            <Route path="/ptorreasons" element={<PtorReasons />} />
            <Route path="/hakalareasons" element={<HakalaReasons />} />
            <Route path="/amotmedacats" element={<AmotMedaCats />} />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/evaluationinstitute"
              element={<EvaluationInstitute />}
            />
            <Route path="/mayors" element={<Mayors />} />
            <Route path="/hotmeem" element={<Hotmeem />} />
            <Route path="/jobtypes" element={<JobTypes />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/mekhrazadmin/:id" element={<MekhrazAdmin />} />
            <Route
              path="/bhinameetingadmin/:mekhraz_id/:department"
              element={<BhinaMeetingAdmin />}
            />

            <Route path="/moamadadmin" element={<MoamadAdmin />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={["moamadeem"]} />}>
            <Route path="/moamadoiot" element={<Moamadoiot />} />
            <Route
              path="/moamadoot/:moamad_id/:mekhraz_title/:hagsha_aharon"
              element={<Moamadoot />}
            />
          </Route>
          <Route path="/moamadootreview" element={<GetMekhrazeem />} />
          <Route
            path="/Displaymoamadiot/:mekhraz_id/:member_id"
            element={<DisplayMoamadiot />}
          />
          <Route
            element={<RequireAuth allowedRoles={["managers", "viewers"]} />}
          >
            <Route path="/users" element={<Users />} />
            <Route path="/getloggedinusers" element={<GetLoggedInUsers />} />
            <Route path="/exportusers" element={<ExportDataButton />} />
            <Route path="/getloginlog" element={<GetLoginLog />} />
            <Route
              path="/exportmoamadeem"
              element={<ExportMoamadeemButton />}
            />
            <Route
              path="/exportmekhrazeem"
              element={<ExportMekhrazeemButton />}
            />
          </Route>

          {/* catch all */}
          <Route path="*" element={<Missing />}></Route>
        </Routes>
      </div>
    </>
  );
}
//bypassRoleCheck={true}
export default App;
